import { makeAuthenticatedRequest } from "./marketOverviewApi";
import { getApiUrl } from "../utils/envConfig";
import type { components } from "./generated/schema";

// Request/response contracts sourced from the FastAPI OpenAPI schema via
// openapi-typescript (npm run gen:api-types). These types are generated
// from the backend Pydantic models, so they can't drift from what the API
// actually accepts and returns — CI fails the build if schema.ts is stale.
type SavedFilterViewResponse =
  components["schemas"]["SavedFilterViewResponse"];
type CreateSavedFilterViewRequest =
  components["schemas"]["CreateSavedFilterViewRequest"];
type UpdateSavedFilterViewRequest =
  components["schemas"]["UpdateSavedFilterViewRequest"];

export const fetchSavedFilterViews = async ({
  id_client,
}: {
  id_client: string;
}): Promise<SavedFilterViewResponse[]> => {
  const url = `${getApiUrl()}/${id_client}/saved_filter_views`;
  return makeAuthenticatedRequest(url);
};

export const createSavedFilterView = async ({
  id_client,
  name,
  description,
  country,
  applied_filters,
  selected_skus,
  created_by_name,
  created_by_email,
  visibility = "private",
}: CreateSavedFilterViewRequest & {
  id_client: string;
}): Promise<SavedFilterViewResponse> => {
  const url = `${getApiUrl()}/${id_client}/saved_filter_views`;
  return makeAuthenticatedRequest(url, {
    method: "POST",
    body: JSON.stringify({
      name,
      description,
      country,
      applied_filters,
      selected_skus,
      created_by_name,
      created_by_email,
      visibility,
    }),
  });
};

export const updateSavedFilterView = async ({
  id_client,
  id_view,
  name,
  description,
  applied_filters,
  selected_skus,
  visibility,
}: UpdateSavedFilterViewRequest & {
  id_client: string;
  id_view: string;
}): Promise<SavedFilterViewResponse> => {
  const url = `${getApiUrl()}/${id_client}/saved_filter_views/${id_view}`;
  return makeAuthenticatedRequest(url, {
    method: "PUT",
    body: JSON.stringify({ name, description, applied_filters, selected_skus, visibility }),
  });
};

export const duplicateSavedFilterView = async ({
  id_client,
  id_view,
  created_by_name,
  created_by_email,
  visibility = "private",
}: {
  id_client: string;
  id_view: string;
  created_by_name?: string;
  created_by_email?: string;
  visibility?: string;
}): Promise<SavedFilterViewResponse> => {
  const params = new URLSearchParams({ visibility });
  if (created_by_name) params.set("created_by_name", created_by_name);
  if (created_by_email) params.set("created_by_email", created_by_email);
  const url = `${getApiUrl()}/${id_client}/saved_filter_views/${id_view}/duplicate?${params}`;
  return makeAuthenticatedRequest(url, { method: "POST" });
};

export const deleteSavedFilterView = async ({
  id_client,
  id_view,
}: {
  id_client: string;
  id_view: string;
}): Promise<void> => {
  const url = `${getApiUrl()}/${id_client}/saved_filter_views/${id_view}`;
  return makeAuthenticatedRequest(url, { method: "DELETE" });
};
